import React from 'react';
import { SVGS } from '../assets';
import { OfflineTaskType, TripCheckInLocation } from '@zonofi/zono-money-store';

interface CheckInCheckOutTaskProps {
  type: OfflineTaskType;
  payload?: TripCheckInLocation;
  timestamp: number;
}

export const CheckInCheckOutTask: React.FC<CheckInCheckOutTaskProps> = ({
  timestamp,
  type,
  payload,
}) => {
  const imgSrc =
    type === OfflineTaskType.CHECK_IN ? SVGS.CheckIn : SVGS.CheckOut;
  const msg =
    type === OfflineTaskType.CHECK_IN ? 'Check-in at' : 'Check-out at';

  const openMap = () => {
    const lat = payload?.lat;
    const lng = payload?.lng;
    if (lat && lng) {
      const url = `https://www.google.com/maps?q=${lat},${lng}`;
      window.open(url, '_blank');
    }
  };

  return (
    <div className="check-in-item">
      <div className="check-in-item-info font-regular">
        <img src={imgSrc} />
        <span>{`${msg} ${formatDateTime(timestamp)}`}</span>
      </div>
      {type === OfflineTaskType.CHECK_IN && (
        <div className="check-in-item-location font-semibold" onClick={openMap}>
          View Location
        </div>
      )}
    </div>
  );
};

const formatDateTime = (timestamp: number) => {
  const date = new Date(timestamp);
  const formatted = new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  })
    .format(date)
    .replace(',', '');
  return formatted;
};
